export class OrderSetting {
  isTender: boolean = false;
  disableInvoicing: boolean = false;
}
